import { createStore } from 'vuex'
import { defaultLang } from '@/config/lang'
import { getUser, setUser } from '@/utils'

export default createStore({
  state: {
    locale: defaultLang,
    cpUserInfo: getUser()
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale
    },
    SET_CP_USER_INFO(state, cpUserInfo) {
      setUser(cpUserInfo)
      state.cpUserInfo = cpUserInfo
    }
  },
  actions: {
  },
  modules: {
  }
})
